<template>
  <div>
    <pageTitle />
    <business-group ref="businessGroup" :tableConfig="{...tableConfig}" :formConfig="{...formConfig}">
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input-search style="width: 270px" placeholder="操作人员/操作类型/操作内容/ip地址" v-decorator="['keyword']" @search="OnSearch" />
        </a-form-item>
      </template>
    </business-group>
  </div>
</template>

<script>
const columns = [
  {
    title: "操作人员",
    dataIndex: "username",
    key: "username",
    align: "center"
  },
  {
    title: "操作类型",
    dataIndex: "operationType",
    key: "operationType",
    align: "center"
  },
  {
    title: "操作内容",
    dataIndex: "operationDesc",
    key: "operationDesc",
    align: "center"
  },
  {
    title: "IP地址",
    dataIndex: "terminalIp",
    key: "terminalIp",
    align: "center"
  },
  {
    title: "操作时间",
    dataIndex: "createTime",
    key: "createTime",
    align: "center"
  }
];

import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";


export default {
  components: {
    pageTitle,
    businessGroup
  },
  data() {
    return {
      tableConfig: {
        url: "/bluetoothlight/web/system/logs",
        columns,
        rowKey: "logId",
        loading: false
      },
      formConfig: {
        formShow: true,
        timeShow: true
      }
    };
  },
  methods: {
    OnSearch() {
      this.$refs?.businessGroup?.submit();
    }
  }

};
</script>


<style lang="less" scoped>
.header {
  display: flex;

  .admin_add {
    float: right;
    width: 100px;
    height: 30px;
    font-size: 12px;
    border: none;
    background-color: #2A82E4;
    border-radius: 5px;
    color: #fff;
  }
}
</style>
